module.exports = __webpack_public_path__ + "img/notFound.d1bef2f8.svg";